import { Validator } from '../../../core/Types';

export const PasswordForgetValidator: Validator[] = [
    {
        name: "email",
        required: true,
        type: "Email"
    }
 ];